
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/shadows.st.css.js";
import "./Pagination/Pagination.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_182_0_Carousel";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_182_0_Carousel__root","controls":"wds_1_182_0_Carousel__controls","imageContainer":"wds_1_182_0_Carousel__imageContainer","image":"wds_1_182_0_Carousel__image","loader":"wds_1_182_0_Carousel__loader","pagination":"wds_1_182_0_Carousel__pagination","pageNavigation":"wds_1_182_0_Carousel__pageNavigation","arrowPrevBackground":"wds_1_182_0_Carousel__arrowPrevBackground","arrowNextBackground":"wds_1_182_0_Carousel__arrowNextBackground"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"horizontalSpacingSize":"50px","verticalSpacingSize":"7px"}; 
export var vars = {"arrow-size":"--wds_1_182_0_Carousel-arrow-size","carousel-gradient-color":"--carousel-gradient-color"}; 




